
import { Component } from 'vue-property-decorator';
import Page from '@/Page.vue';
import PanelDashboard from '@/libs/panel-dashboards/pages/PanelDashboard.vue';
import { tenantsStore } from '@/libs/tenants/+state/store';
import { CrudGetter } from '@/libs/core/+state/models/crud-getter';
import { TenantModel } from '@/libs/Api';

@Component({
    components: { PanelDashboard },
})
export default class QuickLoginPanelDashboardDialog extends Page {
    protected dialog = true;

    protected get tenant(): TenantModel {
        return tenantsStore.useGetter(CrudGetter.Detail);
    }

    protected get panelId(): string {
        return window.localStorage.ActivePanelDashboard;
    }
}
